import request from '@/config/request'

export default {
    initQuestionAndAnswer: function (type, sex, age) {
        return request({
            url: '/health/healthquestion/initquestionandanswer',
            method: 'get',
            params: {
                type: type,
                sex: sex,
                age: age
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/health/healthquestion.js